module.exports = "<!-- Tabla inicial -->\n<div class=\"row\">\n  <div class=\"col-12 dy-table\">\n    <ng2-smart-table [settings]=\"settings\" [source]=\"source\"></ng2-smart-table>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/creation-dynamic-component/creation-form/type-documentary/type-documentary.component.html
// module id = ./src/app/administration/creation-dynamic-component/creation-form/type-documentary/type-documentary.component.html
// module chunks = main